import React from "react";
import PropTypes from "prop-types";
import { DateTime } from "luxon";
import styled from "styled-components";

import { Card, ColorPalette, StyledBody1, FontColors } from "yuka";

const StyledContainer = styled.div`
  margin-top: 16px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${ColorPalette.white15};
`;

const StyledStockSplitCard = styled(Card)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  padding: 16px;
`;

const StyledLight = styled.span`
  ${FontColors.theme50}
`;

/**
 * Displays stock split data between `<FundingRoundTable />`.
 *
 * @param {object} props
 * @returns {React.Element}
 */
const StockSplitRow = ({ split }) => {
  const date = DateTime.fromISO(split.date).toLocaleString({
    month: "short",
    year: "numeric",
  });
  const multiplier = parseFloat(split.multiplier).toString();
  const description = `${multiplier}:1 Stock Split`;
  return (
    <StyledContainer>
      <StyledStockSplitCard>
        <StyledBody1>
          <span>{description}&nbsp;</span>
          <StyledLight>{date}</StyledLight>
        </StyledBody1>
      </StyledStockSplitCard>
    </StyledContainer>
  );
};

StockSplitRow.propTypes = {
  split: PropTypes.shape({
    date: PropTypes.string,
    multiplier: PropTypes.number,
  }).isRequired,
};

export default StockSplitRow;
